import { render } from "./ColisListe.vue?vue&type=template&id=85980110&ts=true"
import script from "./ColisListe.vue?vue&type=script&lang=ts"
export * from "./ColisListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__